import { render } from "./TeamMessages.vue?vue&type=template&id=c0ed6dde"
import script from "./TeamMessages.vue?vue&type=script&lang=js"
export * from "./TeamMessages.vue?vue&type=script&lang=js"

import "./TeamMessages.vue?vue&type=style&index=0&id=c0ed6dde&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__